var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 18.15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.71C6.08 17.71.43 10.17.2 9.85a1 1 0 0 1 0-1.19C.43 8.34 6.08.81 13 .81s12.57 7.53 12.8 7.85a1 1 0 0 1 0 1.19c-.23.32-5.88 7.86-12.8 7.86ZM2.28 9.26C3.71 11 8.13 15.71 13 15.71S22.29 11 23.72 9.26C22.29 7.56 17.87 2.81 13 2.81S3.71 7.56 2.28 9.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.44a5.18 5.18 0 1 1 5.18-5.18A5.19 5.19 0 0 1 13 14.44Zm0-8.36a3.18 3.18 0 1 0 3.18 3.18A3.19 3.19 0 0 0 13 6.08Z"
  })));
};
export default SvgEye;